import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
//Styles
import * as Styles from './Footer.Styles';
//Components
import { Container } from '../Container/Container.Styles';
import Slider from './../Slider/Slider';
import Map from './../Map/Map';
import ContainerBG from '../ContainerBG/ContainerBG';

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      aboutBg: file(name: { eq: "about-bg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, quality: 80)
        }
      }
      slider: allFile(filter: { relativeDirectory: { eq: "Slider" } }) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, quality: 80)
            }
          }
        }
      }
      icons: allFile(
        filter: { relativeDirectory: { eq: "Icons" } }
        sort: { fields: name, order: ASC }
      ) {
        edges {
          node {
            publicURL
            name
          }
        }
      }
    }
  `);
  return (
    <>
      <ContainerBG image={data.aboutBg.childImageSharp.gatsbyImageData}>
        <Container
          height='100vh'
          fluid
          bgColor='rgba(39, 42, 46, 0.72)'
          bgBlend='multiply'
          flex
          flexDir='column'
          padding='16px'>
          <Container color='#fff'>
            <h2>O nas</h2>
          </Container>
          <Styles.AboutSection flex alignItems='stretch' maxHeight='500px'>
            <Container
              bgColor={({ theme }) => theme.colors.primaryColor}
              padding='16px'
              color='#fff'
              flex
              style={{ boxShadow: '0px 0px 6px rgb(0 0 0 / 75%)' }}>
              <Styles.AboutText>
                <p>
                  Pozwolą Państwo, że się przedstawimy. Jesteśmy dwie Kamy –
                  Biała i Ruda.
                </p>
                <p>
                  Kama Biała miała kiedyś marzenie, że otworzy salon tapet,
                  który będzie bardziej niesamowity niż jej wyobrażenia. A
                  ponieważ sama jest niesamowita, nie mogła przyciągnąć do
                  siebie nikogo zwyczajnego, więc odnalazła Kamę Rudą i odtąd
                  obie wymachują magicznymi różdżkami wokół stołów do tapet.
                </p>
                <p className='no-indent'>A teraz na poważnie...</p>
                <p>
                  Jesteśmy zespołem ludzi związanych z tapetami wieloletnim
                  uczuciem. Wiemy, że tapety mają magiczną moc przemiany
                  wnętrza. Regularnie uzupełniamy półki o nowe katalogi,
                  codziennie przeglądamy tysiące wzorów i naprawdę wierzymy, że
                  nasza oferta jest w stanie zaspokoić nawet najwybredniejsze
                  gusta.
                </p>
                <p>
                  Chcemy, aby nasz salon wyróżniał się nie tylko ofertą, ale i
                  atmosferą. Szukasz czegoś wyjątkowego dla swojego domu?
                  Poszukamy z Tobą! Przy kawie i ciasteczku, bez pośpiechu
                  poznamy Twoje upodobania i postaramy się spełnić marzenia o
                  pięknych ścianach. Daj nam się poznać! Dla nas jesteś kimś
                  więcej niż tylko klientem!
                </p>
              </Styles.AboutText>
            </Container>
            <Container flex>
              <Slider gatsbyImageData={data.slider.edges} />
            </Container>
          </Styles.AboutSection>

          <Container color='#fff' id='kontakt'>
            <h2>Kontakt</h2>
          </Container>

          <Container flex alignItems='stretch'>
            <Container
              flex
              flexDir='column'
              color='black'
              bgColor='#fff'
              padding='16px'
              alignItems='flex-start'>
              <Styles.ContactWrapper>
                <Styles.ContactItem>
                  <img
                    src={data.icons.edges[5].node.publicURL}
                    alt={data.icons.edges[5].node.name}
                  />
                  ul. Moniuszki 2, 75-557 Koszalin
                </Styles.ContactItem>
                <Styles.ContactItem>
                  <img
                    src={data.icons.edges[4].node.publicURL}
                    alt={data.icons.edges[4].node.name}
                  />
                  94 343 08 32
                </Styles.ContactItem>
                <Styles.ContactItem>
                  <img
                    src={data.icons.edges[3].node.publicURL}
                    alt={data.icons.edges[3].node.name}
                  />
                  zona@tapety-koszalin.pl - Kama Biała
                </Styles.ContactItem>
                <Styles.ContactItem>
                  <img
                    src={data.icons.edges[3].node.publicURL}
                    alt={data.icons.edges[3].node.name}
                  />
                  kamila@tapety-koszalin.pl - Kama Ruda
                </Styles.ContactItem>
              </Styles.ContactWrapper>
              <Styles.ContactAddress>
                <img
                  src={data.icons.edges[0].node.publicURL}
                  alt={data.icons.edges[0].node.name}
                />
                <span>
                  Poniedziałek - piątek: 9<sup>00</sup>-17<sup>00</sup>
                  <br />
                  Sobota: 9<sup>00</sup>-13<sup>00</sup>
                </span>
              </Styles.ContactAddress>
            </Container>
            <Styles.ContactMap height='300px' flex>
              <Map />
            </Styles.ContactMap>
          </Container>
        </Container>
        <Container fluid bgColor='#fff' padding='30px 8px'>
          <Styles.FooterContainer flex>
            <footer>
              <h2>ZONA</h2>
              <p>Najpiękniejsze tapety w Koszalinie </p>
              <div className='social-icons'>
                <a href='https://www.facebook.com/Najpi%C4%99kniejsze-tapety-w-Koszalinie-ZONA-salon-wyposa%C5%BCenia-wn%C4%99trz-235821219884713/'>
                  <img
                    src={data.icons.edges[1].node.publicURL}
                    alt={`${data.icons.edges[1].node.name} link icon`}
                  />
                </a>
                <a href='https://www.instagram.com/zonatapety/'>
                  <img
                    src={data.icons.edges[2].node.publicURL}
                    alt={`${data.icons.edges[2].node.name} link icon`}
                  />
                </a>
              </div>
            </footer>
          </Styles.FooterContainer>
        </Container>
      </ContainerBG>
    </>
  );
};
export default Footer;
